import { requests } from './agent'

const Contact = {
  sendMessages: (name: string, email: string, subject: string, message: string) =>
    requests.get(
      `/profile/sendMessage?name=${name}&email=${email}&subject=${subject}&message=${message}`,
    ),
}

export default Contact
